import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'

type IChangeEmailModalActionsProps = {
  store: ProfileStore
}

export const ChangeEmailModalActions = observer(({ store }: IChangeEmailModalActionsProps) => {
  const {
    loading,
    currentPasswordConfirmed,
    email,
    newEmail,
    handleChangeEmailSave,
    onCloseModal,
  } = store

  const isSaveDisabled =
    loading || !currentPasswordConfirmed || !newEmail.trim() || email === newEmail

  return (
    <>
      <Button
        text='Cancel'
        onClick={onCloseModal}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text='Save'
        onClick={handleChangeEmailSave}
        disabled={isSaveDisabled}
        loading={loading}
      />
    </>
  )
})
